import { Text } from "@amzn/storm-ui";
import React from "react";

interface LabelledTextFieldProps {
    label: string;
    value: string | number | boolean;
}

export const LabelledTextField: React.FunctionComponent<
    LabelledTextFieldProps
> = ({ label, value }) => {
    const valueStr = `${value}`;
    const hasLineBreaks = valueStr.includes("\n");

    return (
        <Text style={hasLineBreaks ? { whiteSpace: "pre-line" } : undefined}>
            <strong>{label}:</strong> {valueStr}
        </Text>
    );
};
